import React, { ReactElement } from 'react';

import Button from 'components/form/button/button';
import { useTranslate } from 'hooks/translate';

interface TabNavigationProps {
  onContinue: (arg: any) => void;
  onPrevious?: (arg: any) => void;
  hasPrevious?: boolean;
  continueText: string;
  previousText?: string;
  busy?: boolean;
  canContinue?: boolean;
}

export default function TabNavigation({
  onContinue,
  onPrevious,
  hasPrevious,
  continueText,
  previousText,
  busy = false,
  canContinue = true,
}: TabNavigationProps): ReactElement {
  const { t } = useTranslate();

  return (
    <div className='navigation'>
      <Button
        action={onContinue}
        disabled={busy || !canContinue}
        className='primary with-next-icon'
      >
        {busy ? t('reservation.loading') : continueText}
      </Button>
      {hasPrevious ? (
        <Button action={onPrevious} disabled={busy} className='secondary'>
          {previousText}
        </Button>
      ) : (
        <></>
      )}
    </div>
  );
}
